import React from "react";
import PageContainer from "components/PageContainer";

const NotFound = () => (
  <PageContainer>The specified page was not found.</PageContainer>
);

export default NotFound;
